// Feature flags (2026-01): Activity creation & surveys are free; disable face recognition entry points.
export const FEATURE_ACTIVITY_PAYMENT_ENABLED = false;
export const FEATURE_SURVEY_ENABLED = true;
export const FEATURE_FACE_RECOGNITION_ENABLED = false;

